import AzureADLogin from "../admin/login/AzureAD";

export default function Login() {
  return (
    <>
      <div className="flex-colomn gap-2">
        <AzureADLogin />
      </div>
    </>
  );
}
